export const FETCH_START = 'incidents/FETCH_START'
export const FETCH_SUCCESS = 'incidents/FETCH_SUCCESS'
export const FETCH_FAILURE = 'incidents/FETCH_FAILURE'

export const SELECT_INCIDENTS = 'incidents/SELECT_INCIDENTS'
export const NEXT_INCIDENT = 'incidents/NEXT_INCIDENT'
export const PREV_INCIDENT = 'incidents/PREV_INCIDENT'
export const CLEAR_SELECTION = 'incidents/CLEAR_SELECTION'

export const HOVER = 'incidents/HOVER'
export const END_HOVER = 'incidents/END_HOVER'
